import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ProcessStep from "../../ProcessStep/ProcessStep"
import { fadeIn } from '../../../Functions/GlobalAnimations'
import { ProcessStepData01 } from '../../ProcessStep/ProcessStepData'
import HeaderCompo from '../../HeaderComp/HeaderCompo'
export const DiscoverNpos = () => {
    return (
        <>
            <section className="py-[70px] max-sm:py-[70px] bg-gray-100 lg:py-[70px] md:py-[70px] sm:py-[50px] overflow-hidden">
                <Container >
                    <Row className="justify-center ">
                        <Col xl={6} sm={8} className="text-center max-sm:mb-10 mb-18 sm:mb-12">    
                            <HeaderCompo tagType='h1' className="SealsSecHeader  max-sm:text-3xl max-md:text-4xl" text="Discover NPOs across India"/>
                        </Col>
                        <ProcessStep grid="row-cols-1 row-cols-lg-4 row-cols-sm-2 gap-y-10"
                            theme='process-step-style-01' className=""
                            data={ProcessStepData01} animation={fadeIn} />
                    </Row>
                </Container>
            </section>
        </>
    )
}
